import { registerValidator } from 'core/forms';

function isNotMaxLengthOfCharacters({
  model,
  schema,
}) {
  const { title } = model;

  const { maxLengthOfCharacters } = schema;

  const stringLength = title.length;

  const error = `Title must be no longer than ${maxLengthOfCharacters} characters.`;

  if (stringLength <= maxLengthOfCharacters) {
    return {
      hasError: false,
    };
  }

  return {
    hasError: true,
    error,
  };
}

registerValidator('isNotMaxLengthOfCharacters', isNotMaxLengthOfCharacters);

export default isNotMaxLengthOfCharacters;
